// extracted by mini-css-extract-plugin
export default {"project":"projects_project__KtbCo","container":"projects_container__+hGkh","projects_container":"projects_projects_container__V66fL","main_text":"projects_main_text__18EEx"};